import Reactive from './reactive';

class SFUWebSocket extends Reactive {
  constructor(params) {
    super(params);
    this.prop('ro', 'wsuri', params.wsuri);
    // Conneciton RETRY INTERVAL
    this.prop('rw', 'retryInterval', params.retryInterval || 500);

    this.prop('rw', 'stopped', false);
    this.prop('rw', 'sock', null);
    this.prop('rw', 'task', null);
    // outbound messages queue
    this.prop('rw', 'outbound', []);
  }

  sendOutboundQueue() {
    this.outbound.forEach((message) => {
      // sending old messages
      // console.log("message", this.outbound)
      this.sock.send(JSON.stringify(message));
    });
    this.update({ outbound: [] });
  }

  send(message) {
    // store it to send it at a later time
    this.outbound.push(message);

    // if its ReadyState is "Open"
    // https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/readyState
    if (this.sock.readyState !== 1) { return; }

    this.sendOutboundQueue();
  }

  stop() {
    this.update({ stopped: true });
    this.sock.close();
  }

  setupWebSocket() {
    // this.startTask();
    const sock = new WebSocket(this.wsuri);
    const that = this;
    sock.onopen = function () {
      // if (that.task) {
      //   console.log("CONNECTED SUCCESSFULLY TO SFU")
      //   that.task.done();
      //   that.update({ task: null });
      that.sendOutboundQueue();
      // }

      that.update({retryInterval: 500});
      that.emit('connected');
    };
    sock.onclose = function (e) {
      that.emit('disconnected');
      console.log('Closed socket', that.wsuri);
      if (that.stopped) { return; }
      window.setTimeout(() => {
        that.setupWebSocket();
      }, that.retryInterval);
    };
    sock.onmessage = function (e) {
      // console.log("websocket message received: " + e.data);
      const data = JSON.parse(e.data);
      data.forEach((element) => {
        if (typeof (element) === 'string') {
          if (element.length > 0) {
            element = JSON.parse(element);
          } else {
            // its just an empty "" message ignore
            return;
          }
        }
        if (element == null) console.error(`null data message received: ${e.data}`);
        that.emit('websocketMessage', element);
      });
    };
    sock.onerror = function (e) {
      console.error(`websocket error:`, e, that.retryInterval);
      // theres a ceiling
      if (that.retryInterval < 5000){
        that.update({retryInterval: that.retryInterval*(2 + Math.random())});
      }
    };
    this.update({ sock });
  }
}
function setupWebSocket(url) {
  const socket = new SFUWebSocket({ wsuri: url });
  socket.setupWebSocket();
  return socket;
}

export { setupWebSocket };
